import { Component, Input, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { SystemController } from '@shared/src/controllers/system/system.controller';
import { FileUpDownLoadDto } from '@shared/src/dtos/base/FileUpDownLoadDto';
import { ImageTypes } from '@shared/src/enums/ImageTypes';
import { SecurityController } from '@shared/src/public-api';

@Component({
  selector: 'shared-external-cmr-agent-bar',
  templateUrl: './shared.external.cmr.agent.bar.component.html',
  styleUrls: ['./shared.external.cmr.agent.bar.component.scss'],
})
export class SharedExternalCMRAgentBarComponent implements OnInit {

  constructor(@Inject('SecurityController') private securityController: SecurityController,
      protected systemController: SystemController) { }

  @Output() clickBack = new EventEmitter<boolean>();

  @Input() public showButtonBack: boolean = true;
  @Input() public goBackToHome: boolean = false;
  @Input() public tenantId: number;
  
  ngOnInit() {
    
  }

  public goHome() {
  }

  public back() {
    if (this.goBackToHome)
      this.securityController.goToHome();
    else
      this.clickBack.next(true);
  }
}
